import loadable from "@loadable/component";
import React from "react";
import LoadableLoading from "components/LoadableScreen/LoadableLoading";

export const Loadable_Login = loadable(() => import("screen/Login/Login2"), {
    fallback: LoadableLoading,
});

export const Loadable_BasicLogin = loadable(
    () => import("screen/Login/BasicLogin"),
    {
        fallback: LoadableLoading,
    }
);

export const Loadable_Company = loadable(
    () => import("screen/Company/Company2"),
    {
        fallback: LoadableLoading,
    }
);

export const Loadable_OrderForm = loadable(
    () => import("screen/Form/OrderForm/OrderForm"),
    {
        fallback: LoadableLoading,
    }
);

export const Loadable_Home = loadable(() => import("screen/Home/Home2"), {
    fallback: LoadableLoading,
});

export const Loadable_Loading = loadable(
    () => import("screen/Loading/Loading2"),
    {
        fallback: LoadableLoading,
    }
);
